import { CardFooter as CardFooterBase } from "../../../components/lib/Card";
import { styled } from "../../../stitches.config";

export * from "../../../components/lib/Card";

export const CardFooter = styled(CardFooterBase, {
  padding: "$4",
  borderTop: "1px solid $primaryLighter",
});
